import { render, staticRenderFns } from "./tsg-engine-controls-header.vue?vue&type=template&id=298b3460&scoped=true"
import script from "./tsg-engine-controls-header.vue?vue&type=script&lang=js"
export * from "./tsg-engine-controls-header.vue?vue&type=script&lang=js"
import style0 from "./tsg-engine-controls-header.vue?vue&type=style&index=0&id=298b3460&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298b3460",
  null
  
)

export default component.exports